module.exports = __webpack_public_path__ + "static/media/ic_host.c1d3abd0.svg";